import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  fetchMetalRewardsRequest,
  fetchMetalRewardsSuccess,
  fetchMetalRewardsFailure,
  updateStatusRequest,
  updateStatusSuccess,
  updateStatusFailure,
  getMetalRewardRequest,
  getMetalRewardSuccess,
  getMetalRewardFailure,
  createMetalRewardRequest,
  createMetalRewardSuccess,
  createMetalRewardFailure,
} from "./metalRewardsSlice";
import { toast } from "react-toastify";

// Fetch Metal Rewards list
function* fetchMetalRewards(action) {
  try {
    const payload = action.payload || { start: 0, limit: 10 };

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/metal-reward/listMetalRewards`,
        { params: payload }
      )
    );

    const apiData = response.data?.data;
    // console.log("apiData", apiData);

    yield put(
      fetchMetalRewardsSuccess({
        data: apiData?.data || [],
        total: apiData?.recordsTotal || 0,
        page: Math.floor((payload.start || 0) / (payload.limit || 10)) + 1,
        limit: payload.limit || 10,
      })
    );
  } catch (error) {
    yield put(fetchMetalRewardsFailure(error.message));
    toast.error("Failed to fetch Metal Rewards");
  }
}

// Update status
function* handleUpdateStatus(action) {
  try {
    const { id, enabled } = action.payload;

    const response = yield call(() =>
      axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/metal-reward/updateStatus`,
        { id, enabled }
      )
    );
    const { message, success, data } = response.data;

    if (success && data) {
      yield put(
        updateStatusSuccess({ id, status: enabled ? "Enable" : "Disable" })
      );
      toast.success(message || "Status updated successfully");
      yield put(fetchMetalRewardsRequest());
    } else {
      toast.warning(message || "Could not update status");
    }
  } catch (error) {
    yield put(updateStatusFailure(error.message));
    toast.error("Failed to update status");
  }
}


// Get single Metal Reward details
function* getMetalReward(action) {
  try {
    const { id } = action.payload;
    console.log("Fetching metal reward data for ID:", id);

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/metal-reward/getMetalRewardData`,
        { params: { id } }
      )
    );

    yield put(getMetalRewardSuccess(response.data?.data || {}));
  } catch (error) {
    console.error("Error fetching metal reward data:", error);
    yield put(getMetalRewardFailure(error.message));
    toast.error("Failed to fetch reward details");
  }
}


// Create Metal Reward
function* createMetalReward(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/metal-reward/setBuyMetalReward`,
        action.payload
      )
    );

    // Success
    yield put(createMetalRewardSuccess(response.data?.data || {}));
    toast.success("Metal Reward created successfully");

    yield put(fetchMetalRewardsRequest());
  } catch (error) {
    yield put(createMetalRewardFailure(error.message));
    toast.error("Failed to create Metal Reward");
  }
}

// Root saga
export function* metalRewardsSaga() {
  yield takeLatest(fetchMetalRewardsRequest.type, fetchMetalRewards);
  yield takeLatest(updateStatusRequest.type, handleUpdateStatus);
  yield takeLatest(getMetalRewardRequest.type, getMetalReward);
  yield takeLatest(createMetalRewardRequest.type, createMetalReward);
}
